module.exports = __webpack_public_path__ + "img/bg4.bbbd6612.png";